import { render, staticRenderFns } from "./CompanyConnections.vue?vue&type=template&id=4e83844b&scoped=true"
import script from "./CompanyConnections.vue?vue&type=script&lang=js"
export * from "./CompanyConnections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e83844b",
  null
  
)

export default component.exports